import React from "react";
import { getEndsInLabel } from "../../../../helpers/endsIn";

type EndsBadgeProps = {
  label: string;
  className?: string;
};

const EndsBadge = ({ label, className }: EndsBadgeProps) => {
  return (
    <div
      className={`inline-flex min-h-4 justify-center items-center gap-2.5 rounded border border-black/8 bg-gradient-botb px-1.5 py-0.5 border-solid ${className ? className : ""}`}>
      <span className={"text-white font-jost text-[11px] font-medium leading-[14px]"}>
        ENDS {getEndsInLabel(label)}
      </span>
    </div>
  );
};

export default EndsBadge;
